export const useMail = () => useNuxtApp().$mail;
